"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const chainList_1 = __importDefault(require("./chainList"));
const coinList_1 = __importDefault(require("./coinList"));
const placeholder_coin_png_1 = __importDefault(require("../../static/assets/placeholder-coin.png"));
const styled_1 = require("./styled");
/**
 * Cryptocurrency coin image
 */
const Coin = (_a) => {
    var { ticker, altSrc, isErc, chain, size = '64px', chainSize = '22px' } = _a, rest = __rest(_a, ["ticker", "altSrc", "isErc", "chain", "size", "chainSize"]);
    const isAvailable = Object.keys(coinList_1.default).includes(ticker === null || ticker === void 0 ? void 0 : ticker.toLowerCase());
    const defaultToken = isErc ? 'erc' : 'placeholder';
    const coin = coinList_1.default[isAvailable ? ticker === null || ticker === void 0 ? void 0 : ticker.toLowerCase() : defaultToken];
    const chainIcon = chain && chainList_1.default[chain.toLowerCase()];
    return (react_1.default.createElement(styled_1.Wrapper, { showChain: !!chain },
        react_1.default.createElement("img", Object.assign({ src: isAvailable ? coin.src : altSrc || coinList_1.default[defaultToken].src, alt: coin.alt, width: size, height: size, onError: e => {
                e.target.src = placeholder_coin_png_1.default;
            } }, rest)),
        chainIcon && (react_1.default.createElement(styled_1.ChainWrapper, null,
            react_1.default.createElement("img", { src: chainIcon.src, alt: chain, width: chainSize, height: chainSize })))));
};
exports.default = Coin;
//# sourceMappingURL=Coin.js.map